import { RegistrationType } from './types/registrationTypes';

export function createDefaultRegistration(): RegistrationType {
  return {
    id: '',
    identifiers: {
      company: '',
      center: '',
      mrn: '',
    },
    name: {
      first: '',
      middle: '',
      last: '',
    },
    addresses: [],
    demographics: {
      gender: '',
      ethnicity: '',
      race: '',
      dateOfBirth: '',
      maritalStatus: '',
    },
    contactInfo: {
      phone: '',
      email: '',
      alternatePhone: '',
    },
  };
}
